module.exports = __webpack_public_path__ + "static/better-employee-charlie-400w-9078c6ae45355e1899c40d1ed8a8ab40.jpg";